export default "__VITE_ASSET__Dwd0mR1n__"